import { RESET_STATE } from 'store/global/actions';

import { PRICE_SOURCE_MATRICES_ACTION_TYPE, PRICE_SOURCES_ACTION_TYPE } from '../actions';

const EMPTY_VERSION = { versionId: null, data: null, isLoading: false, errorMessage: null };

const EMPTY_DEACTIVATE = { versionId: null, isDeactivating: false, errorMessage: null };

const EMPTY_SRP_MATRIX = {
  versionId: null,
  requestId: null,
  data: null,
  isLoading: false,
  errorMessage: null,
};

const initialState = {
  versions: [],
  isLoading: false,
  hasError: false,
  isLoaded: false,
  version: EMPTY_VERSION,
  deactivate: EMPTY_DEACTIVATE,
  srpMatrix: EMPTY_SRP_MATRIX,
};

// Only the latest request's response may land: an earlier product or version must not overwrite it.
const isStaleSrpResponse = (slice, payload) =>
  payload.versionId !== slice.versionId || payload.requestId !== slice.requestId;

const priceSourceMatricesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PRICE_SOURCE_MATRICES_ACTION_TYPE.SET_VERSIONS_LOADING:
      return { ...state, isLoading: true, hasError: false };

    case PRICE_SOURCE_MATRICES_ACTION_TYPE.GET_VERSIONS:
      return { ...state, versions: payload ?? [], isLoading: false, isLoaded: true };

    case PRICE_SOURCE_MATRICES_ACTION_TYPE.SET_VERSIONS_ERROR:
      return { ...state, isLoading: false, hasError: true, isLoaded: true };

    case PRICE_SOURCE_MATRICES_ACTION_TYPE.SET_VERSION_LOADING:
      return { ...state, version: { ...EMPTY_VERSION, versionId: payload, isLoading: true } };

    case PRICE_SOURCE_MATRICES_ACTION_TYPE.GET_VERSION:
      return payload.versionId === state.version.versionId
        ? {
            ...state,
            version: { ...EMPTY_VERSION, versionId: payload.versionId, data: payload.data },
          }
        : state;

    case PRICE_SOURCE_MATRICES_ACTION_TYPE.SET_VERSION_ERROR:
      return payload.versionId === state.version.versionId
        ? {
            ...state,
            version: {
              ...EMPTY_VERSION,
              versionId: payload.versionId,
              errorMessage: payload.errorMessage ?? null,
            },
          }
        : state;

    case PRICE_SOURCE_MATRICES_ACTION_TYPE.SET_DEACTIVATING:
      return {
        ...state,
        deactivate: { ...EMPTY_DEACTIVATE, versionId: payload, isDeactivating: true },
      };

    case PRICE_SOURCE_MATRICES_ACTION_TYPE.SET_DEACTIVATED:
      return { ...state, deactivate: EMPTY_DEACTIVATE };

    case PRICE_SOURCE_MATRICES_ACTION_TYPE.SET_DEACTIVATE_ERROR:
      return {
        ...state,
        deactivate: { ...state.deactivate, isDeactivating: false, errorMessage: payload ?? null },
      };

    case PRICE_SOURCE_MATRICES_ACTION_TYPE.SET_SRP_MATRIX_LOADING:
      return {
        ...state,
        srpMatrix: {
          versionId: payload.versionId,
          requestId: payload.requestId,
          data: state.srpMatrix.versionId === payload.versionId ? state.srpMatrix.data : null,
          isLoading: true,
          errorMessage: null,
        },
      };

    case PRICE_SOURCE_MATRICES_ACTION_TYPE.GET_SRP_MATRIX:
      return isStaleSrpResponse(state.srpMatrix, payload)
        ? state
        : {
            ...state,
            srpMatrix: { ...state.srpMatrix, data: payload.data ?? null, isLoading: false },
          };

    case PRICE_SOURCE_MATRICES_ACTION_TYPE.SET_SRP_MATRIX_ERROR:
      return isStaleSrpResponse(state.srpMatrix, payload)
        ? state
        : {
            ...state,
            srpMatrix: {
              ...state.srpMatrix,
              isLoading: false,
              errorMessage: payload.errorMessage ?? null,
            },
          };

    case PRICE_SOURCE_MATRICES_ACTION_TYPE.CLEAR_SRP_MATRIX:
      return { ...state, srpMatrix: EMPTY_SRP_MATRIX };

    case PRICE_SOURCES_ACTION_TYPE.CLEAR_SOURCE_DETAIL:
    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default priceSourceMatricesReducer;
